module.exports = __webpack_public_path__ + "img/index-d3.bc04d625.png";